/* eslint-disable import/no-default-export,react/no-danger */
import React from 'react';
import { siteDomain } from '@trello/config';

import { CommentDataModel } from 'app/gamma/src/types/models';

import { TrelloMarkdownWrapper } from 'app/gamma/src/util/trello-markdown-config';

import styles from './TrelloMarkdown.less';

export enum MarkdownContentType {
  Comment,
  Description,
  CheckItems,
}

interface AllProps {
  text: string;
  contentType: MarkdownContentType;
  options?: CommentDataModel;
}

export const MarkdownContext = React.createContext<TrelloMarkdownWrapper | null>(
  null,
);

export class TrelloMarkdown extends React.Component<AllProps> {
  formatComment(markdown: TrelloMarkdownWrapper) {
    return markdown.comments.format(this.props.text, {
      siteDomain: siteDomain,
      ...this.props.options,
    }).output;
  }

  formatDescription(markdown: TrelloMarkdownWrapper) {
    return markdown.description.format(this.props.text).output;
  }

  formatCheckItems(markdown: TrelloMarkdownWrapper) {
    return markdown.checkItems.format(this.props.text).output;
  }

  render() {
    return (
      <MarkdownContext.Consumer>
        {(markdown) => {
          let formattedContent: string;

          if (!markdown) {
            throw new Error('MarkdownContext not provided');
          }

          switch (this.props.contentType) {
            case MarkdownContentType.Comment:
              formattedContent = this.formatComment(markdown);
              break;
            case MarkdownContentType.Description:
              formattedContent = this.formatDescription(markdown);
              break;
            case MarkdownContentType.CheckItems:
              formattedContent = this.formatCheckItems(markdown);
              break;
            default:
              throw new Error(
                'Invalid MarkdownContentType for MarkdownContainer.',
              );
          }

          return (
            <div
              className={styles.markdown}
              dangerouslySetInnerHTML={{
                __html: formattedContent,
              }}
            />
          );
        }}
      </MarkdownContext.Consumer>
    );
  }
}
